import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
    selector: 'app-ai-generic-response',
    templateUrl: './ai-generic-response.component.html',
    styleUrls: ['./ai-generic-response.component.scss'],
    standalone: false
})
export class AiGenericResponseComponent implements OnInit {
  now: Date = new Date();

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
              public dialogRef: MatDialogRef<AiGenericResponseComponent>) { }

  ngOnInit(): void {
  }

  refresh(): void {
    this.dialogRef.close(true);
  }

  close(): void {
    this.dialogRef.close(false);
  }

}
